var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[

    'page-shell',

    _vm.pageClass,

    'page-template-default',

    'wp-custom-logo',

    'wp-embed-responsive',

    'post-image-aligned-center',

    'sticky-menu-fade',

    'sticky-enabled',

    'both-sticky-menu',

    'no-sidebar',

    'nav-below-header',

    'separate-containers',

    'header-aligned-left',

    'dropdown-hover',

  ]},[_c('HeadNav',{attrs:{"selectedLanguage":"en","page":_vm.page,"gotodownload":_vm.gotodownload,"apk":_vm.apk}}),_vm._v(" "),(_vm.showBreadcrumb)?_c('nav',{staticClass:"shell-breadcrumb",attrs:{"aria-label":"Breadcrumb"}},[_vm._l((_vm.breadcrumbItems),function(item,index){return [(item.href)?_c('a',{key:item.label + index,attrs:{"href":item.href}},[_vm._v(_vm._s(item.label))]):_c('span',{key:item.label + index,staticClass:"current"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),(index < _vm.breadcrumbItems.length - 1)?_c('span',{key:'sep-' + index,staticClass:"sep"},[_vm._v("/")]):_vm._e()]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"site grid-container container hfeed",attrs:{"id":"page"}},[_c('div',{staticClass:"site-content",attrs:{"id":"content"}},[_c('div',{staticClass:"content-area",attrs:{"id":"primary"}},[_c('main',{staticClass:"site-main",attrs:{"id":"maincontent"}},[_vm._t("default")],2)])])]),_vm._v(" "),(_vm.$global.isMobileDevice() && _vm.showMobileDownload)?_c('div',{staticClass:"fix-bottom-btn",attrs:{"id":"fixed-bottom-btn"},on:{"click":function($event){return _vm.gotodownload()}}},[_vm._v("\n\n    Download WhatsApp Aero APK\n\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }